module.exports = __webpack_public_path__ + "static/media/exit.db673a76.svg";